/** Trim, drop blanks, and de-duplicate "HH:MM" slots for submission. */
export function cleanScheduleTimes(times: string[]): string[] {
  const seen = new Set<string>();
  const out: string[] = [];
  for (const raw of times) {
    const t = raw.trim();
    if (t && !seen.has(t)) {
      seen.add(t);
      out.push(t);
    }
  }
  return out.length > 0 ? out : ["08:00"];
}

export function effectiveScheduleTimes(schedule: {
  schedule_time?: string;
  schedule_times?: string[] | null;
}): string[] {
  if (schedule.schedule_times && schedule.schedule_times.length > 0) {
    return schedule.schedule_times;
  }
  return schedule.schedule_time ? [schedule.schedule_time] : [];
}

export function formatScheduleTimes(schedule: {
  schedule_time?: string;
  schedule_times?: string[] | null;
}): string {
  return effectiveScheduleTimes(schedule).join(", ");
}

const DAY_LABELS = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];

export function formatScheduleDays(days: number[] | null): string {
  if (!days || days.length === 0 || days.length === 7) return "Every day";
  return days
    .slice()
    .sort((a, b) => a - b)
    .map((d) => DAY_LABELS[d] ?? String(d))
    .join(", ");
}

export function formatNextDelivery(iso: string | null | undefined): string {
  if (!iso) return "";
  try {
    return new Date(iso).toLocaleString(undefined, {
      weekday: "short",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      timeZoneName: "short",
    });
  } catch {
    return iso;
  }
}
